import axios from "axios";

export const create = (requestParams, formData, callback) => {
  var promise = axios({
    method: 'post',
    url: Routes.abstract_workflow_edges_path({...{...requestParams}, format: 'json', _options: true }),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    },
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
}

export const update = (requestParams, formData, callback) => {
  var promise = axios({
    method: 'patch',
    url: Routes.abstract_workflow_edge_path({...{...requestParams}, format: 'json', _options: true }),
    data: formData,
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    },
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
}

export const destroy = (requestParams, callback) => {
  var promise = axios({
    method: 'delete',
    url: Routes.abstract_workflow_edge_path({...{...requestParams}, format: 'json', _options: true }),
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    },
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
}

